import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center relative" }
const _hoisted_2 = { class: "relative w-full h-2 bg-gray-200 mt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-full w-full bg-project rounded-md" }, null, -1)
const _hoisted_4 = { class: "flex justify-between w-full" }
const _hoisted_5 = { class: "flex flex-col items-center" }
const _hoisted_6 = { class: "flex flex-col items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "text-sm font-heebo text-project2 font-bold absolute -ml-2",
      style: _normalizeStyle({left: (_ctx.mean / _ctx.max) * 100 + '%'})
    }, _toDisplayString(Math.round(_ctx.mean)) + _toDisplayString(_ctx.unit), 5),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("img", {
        class: "absolute h-4 p-0 -mt-3",
        src: "img/scirt/gumb.png",
        alt: "button icon",
        style: _normalizeStyle({ left: (_ctx.mean / _ctx.max) * 100 + '%' })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, _toDisplayString(_ctx.min) + _toDisplayString(_ctx.unit), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, _toDisplayString(_ctx.max) + _toDisplayString(_ctx.unit), 1)
      ])
    ])
  ]))
}